import { render, staticRenderFns } from "./PaymentGroup.vue?vue&type=template&id=4e90886c"
import script from "./PaymentGroup.vue?vue&type=script&lang=js"
export * from "./PaymentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports